import styled from 'styled-components';

export const DatepickerStyle = {
    Container: styled.div``,
}